import Vue from 'vue'
import VueRouter from 'vue-router'
import accessToken from '../helpers/accessToken';
import routes from './routes';
import store from '../store';
import axios from 'axios';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach( (to, from, next) => {
  document.title = to.meta.title

  if(to.meta.requiresAuth) {
    const token = accessToken.getAccessToken();
    const credentials = accessToken.getCredentials();

    const userData = {
      name : credentials.fullName,
      avatar : credentials.avatar,
      brandID : credentials.brandID,
      brandName : credentials.brandName 
    }

    axios.defaults.headers.common['BUSINESS-ID'] = credentials.brandID;

    store.dispatch('mainStore/setUserDetails', userData);

    if(token) 
      next();
    else {
      next({ name : 'login' })
    }
  }
  next();
}) 

export default router
